function renderSwatchesSlider(element) {
    if (!element || element.closest('swatch-slider')) return;
    var slider = document.createElement('swatch-slider');
    var parent = element.parentNode;
    var next = element.nextSibling;
    slider.appendChild(element);
    parent.insertBefore(slider, next);
}

class SwatchSlider extends HTMLElement {
    connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.track = this.querySelector('.ProductItem__ColorSwatchList');
        if (!this.track) return;

        this.setAttribute('role', 'group');
        this.setAttribute('aria-label', 'Color options');

        this.prevBtn = document.createElement('button');
        this.prevBtn.type = 'button';
        this.prevBtn.className = 'swatch-slider__arrow swatch-slider__arrow--prev';
        this.prevBtn.setAttribute('aria-label', 'Previous colors');
        this.prevBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 11.89L1.03998 6.25L7 0.61L6.65997 0.25L0.309997 6.25L6.65997 12.25L7 11.89Z" fill="currentColor"/></svg>';

        this.nextBtn = document.createElement('button');
        this.nextBtn.type = 'button';
        this.nextBtn.className = 'swatch-slider__arrow swatch-slider__arrow--next';
        this.nextBtn.setAttribute('aria-label', 'Next colors');
        this.nextBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.11L5.96002 6.75L0 12.39L0.340027 12.75L6.69 6.75L0.340027 0.75L0 1.11Z" fill="currentColor"/></svg>';

        this.insertBefore(this.prevBtn, this.track);
        this.appendChild(this.nextBtn);

        this.prevBtn.addEventListener('click', () => {
            this.track.scrollBy({ left: -this.track.clientWidth, behavior: 'smooth' });
        });
        this.nextBtn.addEventListener('click', () => {
            this.track.scrollBy({ left: this.track.clientWidth, behavior: 'smooth' });
        });

        this.track.addEventListener('scroll', () => {
            if (!this._scrollRAF) {
                this._scrollRAF = requestAnimationFrame(() => {
                    this.updateArrows();
                    this._scrollRAF = null;
                });
            }
        });

        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);

        this._onResize = () => this.updateArrows();
        window.addEventListener('resize', this._onResize);

        this.updateArrows();
    }

    updateArrows() {
        var track = this.track;
        if (!track) return;
        var scrollLeft = Math.round(track.scrollLeft);
        var maxScroll = track.scrollWidth - track.clientWidth;
        var hasOverflow = track.scrollWidth > track.clientWidth + 1;

        this.prevBtn.hidden = !hasOverflow || scrollLeft <= 1;
        this.nextBtn.hidden = !hasOverflow || scrollLeft >= maxScroll - 1;
    }

    disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this._scrollRAF) cancelAnimationFrame(this._scrollRAF);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
    }
}

if (!customElements.get('swatch-slider')) {
    customElements.define('swatch-slider', SwatchSlider);
}
